// extracted by mini-css-extract-plugin
export default {"AddressContainer":"Address_AddressContainer__blLGL","show":"Address_show__HmWlG"};